import React from "react";
import { useTranslation } from "react-i18next";

import AddEditAssetRow from "./AddEditAssetRow/AddEditAssetRow";
import { CustomDate } from "../../../../models/custom-date/custom-date";
import { TransactionToAssetAttributionRef } from "../../../../models/transaction-to-asset-attribution";
import { TransactionDTO } from "../../../../models/transactions";

import ConfirmationRemoveItemDialog from "../ConfirmationRemoveItemDialog/ConfirmationRemoveItemDialog";
import { Amounts, HeaderRow, MainBlock, StyledTableCell, TableBodyRow } from "../styles";

interface Props {
  transaction: TransactionDTO;
  readOnly?: boolean;
  handleChange?: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const Assets = ({
  transaction: { assets, legalEntity, currency, transactionDate },
  readOnly = false,
  handleChange,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_transaction.transaction_screen_two.assets"; // tRP - translation root path

  const propsNotIds = assets.length !== 0 ? assets.map((item) => item?.asset?.id as string) : [];

  const handleChangeAsset = (value: TransactionToAssetAttributionRef, idx: number): void => {
    idx < 0
      ? handleChange && handleChange("assets", [...assets, value])
      : handleChange && handleChange("assets", [...assets.slice(0, idx), value, ...assets.slice(idx + 1)]);
  };

  const handleRemoveAsset = (idx: number): void =>
    handleChange && handleChange("assets", [...assets.slice(0, idx), ...assets.slice(idx + 1)]);

  return (
    <>
      <MainBlock>
        <HeaderRow container>
          <StyledTableCell
            flex={2}
            align={"left"}
          >
            Assets
          </StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Amount
          </StyledTableCell>
          <StyledTableCell flex={1}>Exchange rate</StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Booked amount
          </StyledTableCell>
          {!readOnly && (
            <StyledTableCell width={100}>
              <AddEditAssetRow
                handleChangeAsset={(value) => handleChangeAsset(value, -1)}
                legalEntity={legalEntity}
                propsNotIds={propsNotIds}
                currency={currency}
                date={CustomDate.ToDate(transactionDate) as Date}
              />
            </StyledTableCell>
          )}
        </HeaderRow>

        {assets?.map((asset, idx) => {
          return (
            <TableBodyRow
              container
              key={asset.id}
            >
              <StyledTableCell
                flex={2}
                align={"left"}
              >
                {asset?.asset?.name ?? ""}
              </StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+asset?.amount).toLocaleCustom()} ${asset?.currency?.code ?? ""}`}
              >
                <Amounts>{`${(+asset?.amount).toLocaleCustom()} ${asset?.currency?.code ?? ""}`}</Amounts>
              </StyledTableCell>
              <StyledTableCell flex={1}>{asset?.exchangeRate}</StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+asset?.bookedAmount).toLocaleCustom()} ${asset?.bookedCurrency?.code ?? ""}`}
              >
                <Amounts>{`${(+asset?.bookedAmount).toLocaleCustom()} ${asset?.bookedCurrency?.code ?? ""}`}</Amounts>
              </StyledTableCell>
              {!readOnly && (
                <StyledTableCell width={100}>
                  <AddEditAssetRow
                    handleChangeAsset={(value) => handleChangeAsset(value, idx)}
                    legalEntity={legalEntity}
                    item={asset}
                    propsNotIds={propsNotIds}
                    date={CustomDate.ToDate(transactionDate) as Date}
                  />
                  <ConfirmationRemoveItemDialog
                    index={idx}
                    handleRemove={handleRemoveAsset}
                  />
                </StyledTableCell>
              )}
            </TableBodyRow>
          );
        })}
      </MainBlock>
    </>
  );
};

export default Assets;
